/**
 * A user or a group as a small circle with its icon — the picker's options,
 * the share dialog's grants, a role's assignees.
 *
 * One size on purpose. The three copies this replaced had drifted to 28, 30 and
 * 32 pixels with nobody deciding so.
 */
import Avatar from '@mui/material/Avatar';
import type { SubjectType } from '@forsys/shared';
import { SubjectIcon } from './SubjectIcon';

export interface SubjectAvatarProps {
  type: SubjectType;
}

export function SubjectAvatar({ type }: SubjectAvatarProps) {
  return (
    <Avatar sx={{ width: 32, height: 32, bgcolor: 'action.selected' }}>
      <SubjectIcon type={type} sx={{ fontSize: 18 }} />
    </Avatar>
  );
}
